(() => {
  // Mirror the product form on the legacy sticky bar after variant updates.
  let scheduled = false;
  let offerLabel = null, unavailableLabel = null;
  function sync() {
    scheduled = false;
    const sticky = document.getElementById('StickyATCButton');
    const original = document.querySelector('product-form button[id^="ProductSubmitButton-"]');
    if (!original) return;
    const disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
    const label = (original.querySelector('.main-atc__label__text') || original.querySelector('.product-form__submit-label') || original).textContent.trim();
    document.querySelectorAll('[data-velora-stock-delivery]').forEach((line) => {
      const text = disabled && label === 'Hamarosan érkezik' ? label : line.getAttribute('data-velora-stock-delivery');
      if (line.textContent !== text) line.textContent = text;
    });
    if (!sticky) return;
    if (sticky.disabled !== disabled) sticky.disabled = disabled;
    if (sticky.getAttribute('aria-disabled') !== String(disabled)) sticky.setAttribute('aria-disabled', String(disabled));
    const offerOwnsLabel = document.querySelector('.velora-bundle, [data-velora-stack], [data-vcb-cta]');
    if (offerOwnsLabel) {
      const unavailable = /elfogyott|hamarosan érkezik/i.test(label);
      if (disabled && unavailable) {
        if (unavailableLabel === null) offerLabel = sticky.textContent.trim();
        unavailableLabel = label;
      } else if (!disabled && unavailableLabel !== null) {
        if (sticky.textContent.trim() === unavailableLabel && offerLabel) sticky.textContent = offerLabel;
        offerLabel = unavailableLabel = null;
      }
      if (!unavailable) return;
    }
    if (label && sticky.textContent.trim() !== label) sticky.textContent = label;
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  function init() {
    sync();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, characterData: true, attributeFilter: ['disabled', 'aria-disabled'] });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
